module.exports = __webpack_public_path__ + "static/media/play-store.bd13093f.png";